module.exports = __webpack_public_path__ + "img/selected5-min.a5b978da.png";